(function () {
  function formatTimestamp(date) {
    return new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  }

  function initWithdrawalForm(container) {
    const introStep = container.querySelector('[data-withdrawal-step="intro"]');
    const formStep = container.querySelector('[data-withdrawal-step="form"]');
    const openButton = container.querySelector('[data-withdrawal-open]');
    const backButton = container.querySelector('[data-withdrawal-back]');
    const form = container.querySelector('#WithdrawalForm');
    const bodyField = container.querySelector('#WithdrawalForm-body');

    if (!introStep || !formStep || !openButton || !form) return;

    const showForm = () => {
      introStep.classList.add('hidden');
      introStep.hidden = true;
      formStep.classList.remove('hidden');
      formStep.hidden = false;
      const firstInput = form.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    };

    const showIntro = () => {
      formStep.classList.add('hidden');
      formStep.hidden = true;
      introStep.classList.remove('hidden');
      introStep.hidden = false;
      openButton.focus();
    };

    openButton.addEventListener('click', showForm);

    if (backButton) {
      backButton.addEventListener('click', showIntro);
    }

    form.addEventListener('submit', () => {
      const name = form.querySelector('#WithdrawalForm-name')?.value?.trim() || '';
      const order = form.querySelector('#WithdrawalForm-order')?.value?.trim() || '';
      const address = form.querySelector('#WithdrawalForm-address')?.value?.trim() || '';
      const goodsReceiptDate = form.querySelector('#WithdrawalForm-goods-receipt-date')?.value?.trim() || '';
      const email = form.querySelector('#WithdrawalForm-email')?.value?.trim() || '';
      const submittedAt = new Date().toISOString();
      const timestamp = formatTimestamp(new Date(submittedAt));

      if (bodyField) {
        bodyField.value = [
          'Contract withdrawal',
          '',
          `Name: ${name}`,
          `Order number: ${order}`,
          `Address: ${address}`,
          `Date of goods receipt: ${goodsReceiptDate}`,
          `Email: ${email}`,
          `Submitted at: ${timestamp}`,
        ].join('\n');
      }

      const webhookUrl = container.dataset.withdrawalWebhook;
      if (webhookUrl) {
        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name,
            order_number: order,
            address,
            goods_receipt_date: goodsReceiptDate,
            email,
            submitted_at: submittedAt,
          }),
          keepalive: true,
        }).catch(() => {});
      }
    });

    if (form.querySelector('.form-status-list') || form.querySelector('[role="alert"]')) {
      showForm();
    }

    const openFormFromHash = () => {
      if (window.location.hash === '#withdrawal-form') {
        showForm();
      }
    };

    openFormFromHash();
    window.addEventListener('hashchange', openFormFromHash);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-withdrawal-form]').forEach(initWithdrawalForm);
  });
})();
